import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class CreateVehicleIssueDto {
  @Expose()
  vehicleId: string;

  @Expose()
  description: string;

  @Expose()
  notes?: string | null;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  date: Date;
}
